import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, tap, map } from 'rxjs/operators';
import { UnitService } from 'src/app/units/services/unit.service';
import { environment } from 'src/environments/environment';
import {
  UpdateUnitNameLaravelResponse,
  UpdateUnitNameRequest,
  UpdateUnitNameResponse,
} from '../models/update-unit-name.model';
import { adaptToLaravelRequestUpdateUnitName } from '../adapters/adapt_to_laravel_request.adapter';
import { adaptFromLaravelResponseUpdateUnitName } from '../adapters/adapt_from_laravel_response.adapter';

@Injectable({
  providedIn: 'root',
})
export class UpdateNameUnitService {
  constructor(
    private http: HttpClient,
    private newVehicleService: UnitService
  ) {}

  updateUnitName(
    request: UpdateUnitNameRequest
  ): Observable<UpdateUnitNameResponse> {
    const adaptRequest = adaptToLaravelRequestUpdateUnitName(request);
    console.log('adaptRequest', adaptRequest);
    return this.http
      .patch<UpdateUnitNameLaravelResponse>(
        `${environment.apiUrl}/api/update-tracker`,
        adaptRequest.body
      )
      .pipe(
        map((response) => adaptFromLaravelResponseUpdateUnitName(response)),
        tap((response: UpdateUnitNameResponse) => {
          if (response.success) {
            this.newVehicleService.reloadUnits();
          }
        }),
        catchError((error) => {
          console.error('Error al actualizar el nombre de la unidad', error);
          return of({
            success: false,
            message: 'Error al actualizar el nombre de la unidad',
            data: null,
          });
        })
      );
  }
}
